module.exports = __webpack_public_path__ + "img/thumb_24.cc6d6eac.jpg";